import React from 'react';
import { Icon } from '@iconify/react';

import { Box, Button, Tooltip, IconButton } from '@mui/material';

export interface TxToolbarPrimaryAction {
  /** Rótulo do botão primário (ex.: 'Criar OS'). */
  label: string;
  onClick: () => void;
}

interface TxToolbarProps {
  onAdd?: () => void;
  onRefresh?: () => void;
  children?: React.ReactNode; // ← slot para botões extras
  fields?: React.ReactNode; // ← slot para campos de filtro
  /**
   * Ação primária rotulada, 100% opt-in. Sem ela o visual é idêntico ao atual
   * (só IconButtons). O slot `children` continua disponível para botões
   * customizados — ele comporta um `Button` rotulado sem quebrar o layout,
   * pois a área direita é flex com gap; `primaryAction` é só o atalho
   * padronizado, rendido por último, à direita.
   */
  primaryAction?: TxToolbarPrimaryAction;
}

export function TxToolbar({ onAdd, onRefresh, children, fields, primaryAction }: TxToolbarProps) {
  if (!onAdd && !onRefresh && !children && !fields) return undefined;
  const handleAdd = onAdd ?? (() => {});

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1 }}>
      {/* Área para campos de filtro à esquerda */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{fields}</Box>

      {/* Área para botões à direita */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {onRefresh && (
          <Tooltip title="Atualizar" arrow>
            <IconButton size="small" onClick={onRefresh}>
              <Icon icon="solar:refresh-square-outline" width={25} height={25} />
            </IconButton>
          </Tooltip>
        )}
        {onAdd && (
          <Tooltip title="Adicionar novo" arrow>
            <IconButton size="small" onClick={handleAdd}>
              <Icon icon="solar:add-square-broken" width={25} height={25} />
            </IconButton>
          </Tooltip>
        )}
        {children} {/* ← renderiza seus botões customizados */}
        {primaryAction && (
          <Button variant="contained" size="small" onClick={primaryAction.onClick}>
            {primaryAction.label}
          </Button>
        )}
      </Box>
    </Box>
  );
}
